export default __webpack_public_path__ + "static/media/SomeGuy_x600.19ef5515.png";